export default "__VITE_ASSET__DEuQ156t__"